var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.41 10.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #1a1818;\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8441",
    className: "cls-1",
    d: "M8.21,5.78v4.13H.5V2.2h4.13"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_179",
    className: "cls-1",
    x1: 4.35,
    y1: 6.05,
    x2: 9.91,
    y2: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8442",
    className: "cls-1",
    d: "M9.91,3.97V.5h-3.47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.c2bf2106e2675008305ef8daa6b3091e.svg";
export { ForwardRef as ReactComponent };